// src/admin/components/task/FieldEngineerSection.jsx
import React from 'react';
import PersonNameDisplay from '../common/PersonNameDisplay';

export default function FieldEngineerSection({ engineer }) {
  if (!engineer) return null;

  return (
    <div className="border rounded p-4 mb-4">
      <h6 className="fw-semibold mb-3">Assignee Details</h6>
      <div className="row">
        <div className="col-md-6">
          <div className="text-muted small">Name</div>
          <div className="fw-semibold">
            <PersonNameDisplay
              givenName={engineer.given_name}
              familyName={engineer.family_name}
              variant="inline"
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="text-muted small">Company</div>
          <div className="fw-semibold">{engineer.company_name}</div>
        </div>
        <div className="col-md-6 mt-3">
          <div className="text-muted small">Email</div>
          <div className="fw-semibold">{engineer.email}</div>
        </div>
        <div className="col-md-6 mt-3">
          <div className="text-muted small">Phone</div>
          <div className="fw-semibold">{engineer.phone_number}</div>
        </div>
      </div>
    </div>
  );
}
